<template>
    <div :key="tick" class="card shadow"
         :class="type === 'dark' ? 'bg-default': ''">
        <div class="card-header border-0"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
                        Nachweise
                    </h3>
                </div>
                <div class="col text-right">

                    <base-button size="sm" @click="() => { view = 'list'; tick++; changePage(page);}" icon="fas fa-bars"></base-button>
                    <base-button size="sm" @click="() => { view = 'matrix'; tick++; refresh();}" icon="fas fa-th" class="mr-3"></base-button>
                    <base-button v-if="view === 'list'" size="sm" type="secondary" @click="changePage(page)" icon="fas fa-sync-alt"></base-button>
                    <base-button v-else size="sm" type="secondary" @click="refresh" icon="fas fa-sync-alt"></base-button>
                    <base-button type="primary" size="sm" v-on:click="$router.push('/users/profiles_document_create')" icon="ni ni-fat-add"></base-button>
                </div>
            </div>
        </div>

            <matrix v-if="view === 'matrix'" ref="PDMatrix" ></matrix>
            <profile-document-table v-if="view === 'list'" ref="PDTable" :page="page.toString()"></profile-document-table>


        <div class="card-footer d-flex justify-content-end"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <base-pagination v-if="view !== 'matrix'"  :total="totalitems" v-on:input="changePage" :value="page"></base-pagination>
        </div>

    </div>
</template>

<script>
    import ProfileDocumentTable from "@/views/ProfileDocuments/table";
    import Matrix from "@/views/ProfileDocuments/matrix";


    export default {
        name: "list",
        components:{Matrix,ProfileDocumentTable},
        props: {
            type: {
                type: String
            },
            title: String
        },
        data() {
            return {
                totalitems: 0,
                page: 1,
                isLoading: false,
                reportCreation: [],
                view: 'matrix',
                tick: 1
            }
        },
        created() {
          if (!this.$store.getters['country/isReady']) this.$store.dispatch('country/getCountryCollection');
        },
        mounted(){
            //this.changePage(this.page);
        },
        computed: {
            isAdmin() {
                return this.$store.getters['authentication/isAdmin'];
            }
        },
        methods: {
            changePage(page) {
                this.$refs.PDTable.isLoading = true;
                //let url = process.env.VUE_APP_API_SERVER + '/api/profile_documents?order['+orderby+']=['+orderdir+']&page='+page;
                let url = this.$refs.PDTable.getUrl();
                this.$refs.PDTable.getTableData(url).then(
                    response => {
                        this.$refs.PDTable.profileDocuments = response.member;
                        this.totalitems = response.totalItems;
                        this.page = page;
                        this.$refs.PDTable.isLoading = false;
                    }
                )
            },
            refresh() {
                this.isLoading = true;
                //let url = process.env.VUE_APP_API_SERVER + '/api/profile_documents?order['+orderby+']=['+orderdir+']&page='+page;
                //let url = this.$refs.PDMatrix.getUrl();
                this.$refs.PDMatrix.init();
            }
        }
    }
</script>

<style scoped>

</style>